// extracted by mini-css-extract-plugin
export default {"tileWrapper":"GridTile_tileWrapper__C2pS2","title":"GridTile_title__E9i2C","titleActive":"GridTile_titleActive__8HuvS"};